/**
 * Wrapping class to add an order to a MenuItem.
 *
 * @param {number} [order] - Order of the MenuItem. The bigger the number,
 *   the more on the right-hand side the menu item will be
 * @param {MenuItem} menuItem - MenuItem to append to the Menu bar of the editor
 */
export default class OrderedMenuItem {
	constructor({ order, menuItem }) {
		this._order = order;
		this._menuItem = menuItem;
	}

	getOrder() {
		return this._order;
	}

	toMenuItem() {
		return this._menuItem;
	}

	/**
	 * Sort the menu items based on their order.
	 * The biggest the order, the latest in the list is the item.
	 * If no order is provided, the item is put last. In case of order
	 * equality, the order does not change.
	 *
	 * @param {OrderedMenuItem} one - One item to compare
	 * @param {OrderedMenuItem} another - The other item to compare
	 * @return {number}
	 */
	static sort(one, another) {
		const oneOrder = one.getOrder();
		const anotherOrder = another.getOrder();
		if (oneOrder === undefined) {
			if (anotherOrder === undefined) {
				return 0;
			}
			return 1;
		}
		if (anotherOrder === undefined) {
			return -1;
		}

		if (oneOrder === anotherOrder) {
			return 0;
		}

		return oneOrder < anotherOrder ? -1 : 1;
	}
}
